import EventItem from '../../../components/tour/EventItem';

interface Props {
    items: []
}

const Events: React.FC<Props> = (props) => {
    return <>
        {props.items?.map((item: any) => {
            return <EventItem
                key={`event-item-${item.id}`}
                link={"/tour/" + item.id}
                id={item.id}
                status={item.status}
                title={item.title}
                image={item.image}
                price={item.price} />
        })}
    </>
}

export default Events